import { render } from "./ThreeDots.vue?vue&type=template&id=65eb2950&lang=pug"
import script from "./ThreeDots.vue?vue&type=script&lang=js"
export * from "./ThreeDots.vue?vue&type=script&lang=js"

import "./ThreeDots.vue?vue&type=style&index=0&id=65eb2950&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__